export const COLLAPSIBLE_WRAPPER_CLASSES =
  'grid transition-[grid-template-rows,opacity] duration-300 ease-out motion-reduce:transition-none';

export const collapsibleStateClasses = (isCollapsed: boolean) =>
  isCollapsed ? 'grid-rows-[0fr] opacity-0 pointer-events-none' : 'grid-rows-[1fr] opacity-100';
